<p-overlayPanel #op styleClass="shadow-md">
    <ng-template pTemplate="content">
        <div class="border-bottom-1 surface-border flex align-items-center gap-2 w-19rem h-5rem px-3">
            <div>
                <span
                    class="border-circle flex justify-content-center border-circle align-items-center w-3rem h-3rem text-semibold text-primary-300 bg-primary-400"
                    >{{ this.userInfo.logo }}</span
                >
            </div>
            <div>
                <p class="text-color m-0 text-medium">{{ this.userInfo.displayName }}</p>
                <p class="text-gray-300 m-0 text-sm">{{ this.userInfo.username }}</p>
            </div>
        </div>
        <p-button
            styleClass="border-none w-full text-left h-3rem border-round-bottom-lg text-red-500"
            label="{{ 'default-cm-logout' | translate: 'Log out' }}"
            (click)="userLogOut()"
            [loading]="loading"
            icon="pi pi-power-off"
            [outlined]="true"
        >
        </p-button>
    </ng-template>
</p-overlayPanel>
<p-button
    (click)="toggle(op, $event)"
    [icon]="currentIcon"
    iconPos="right"
    [text]="true"
    label="Jhon"
    styleClass="padding-4 border-round-lg  gap-2 hover:surface-hover  border-none focus:surface-ground"
    [outlined]="true"
>
    <ng-template pTemplate="content">
        <span
            class="border-circle flex justify-content-center border-circle align-items-center width-32 height-32 text-semibold text-primary-300 bg-primary-400"
            >{{ this.userInfo.logo }}</span
        >
        <p class="text-color m-0 text-sm text-semibold">{{ this.userInfo.displayName }}</p>
    </ng-template>
</p-button>
